// extracted by mini-css-extract-plugin
module.exports = {"banner":"banner-module--banner--18gEx","inner":"banner-module--inner--2DmVF","headline":"banner-module--headline--21RgB"};